import { Zap, AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

interface Props {
  onUpgradeClick: () => void;
}

export function TrialExpiredGate({ onUpgradeClick }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm">
      <div className="max-w-md w-full mx-4 text-center">
        <div className="flex justify-center mb-6">
          <div className="h-20 w-20 rounded-full bg-destructive/10 flex items-center justify-center">
            <AlertTriangle className="h-10 w-10 text-destructive" />
          </div>
        </div>

        <h1 className="text-2xl font-bold mb-2">Your Free Trial Has Ended</h1>
        <p className="text-muted-foreground mb-8">
          Your 14-day free trial has expired. Upgrade to a paid plan to continue
          using OptiBuild and keep access to all your projects and data.
        </p>

        <Button size="lg" className="gap-2 w-full sm:w-auto" onClick={onUpgradeClick}>
          <Zap className="h-5 w-5" />
          Upgrade Now
        </Button>

        <p className="text-xs text-muted-foreground mt-6">
          Your data is safe and will be available once you upgrade.
          <br />
          Need help? Contact{' '}
          <a href="mailto:support@optibuild.pro" className="text-primary hover:underline">
            support@optibuild.pro
          </a>
        </p>
      </div>
    </div>
  );
}
